<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectChannels" });
import "tailwindcss/tailwind.css";
import { InputCheckboxList } from "../../../../selects/index.js";
import { CHANNELS } from "../../config/channels.js";
import { t } from "svelte-i18n";
export let keys;
export let label = "resource.channel.plural.label";
export let isDisabled = false;
export let isRequired = false;
export let minItems = 1;
export let maxItems = 100;
export let whitelist = [];
const OPTIONS = CHANNELS.map(({ key, label: label2 }) => ({ label: $t(label2), value: key }));
</script>

<div class = 's8-select-channels'>

    <InputCheckboxList
        bind:keys = { keys }
        name = 'channel.keys'
        options = { OPTIONS }
        { isDisabled }
        { isRequired }
        { minItems }
        { maxItems }
        { label }
        { whitelist }
    />

</div>